import { TRootState } from '../reducers';
import { IWidgetSessionState } from '../reducers/types';

export const selectWidgetSessionState = (
  state: TRootState,
): IWidgetSessionState => state.widgetSession;

export const selectWidgetSessionId = (state: TRootState): string | undefined =>
  state.widgetSession.sessionId;
